import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo from "../../../../assets/images/logo.png";
import { DesktopMainMenu, MaterialUISwitch, MenuLink , Containers} from "../styles";
import { toggleTheme } from '../../../../Redux/switchTheme'
import { useDispatch, useSelector } from "react-redux";
import { Container } from "@mui/material";

const DesktopMenu = (props) => {
  const currentTheme = useSelector((state) => state.LDTheme.value)
  const dispatch = useDispatch();

  return (
    <DesktopMainMenu >
      <Containers maxWidth="xl">
      <MenuLink href="/" p="0px">
        <img src={logo} width="76" height='76' alt="Logo" />
      </MenuLink>
      <div style={{display:"flex",alignItems:"center"}}>
        {props.menuList.map((value, i) => <MenuLink key={i} onClick={value.onClick} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink>)}
        {/* <FormControlLabel
          control={
            <MaterialUISwitch 
              sx={{ m: 1 }} 
              checked={currentTheme}
              />
            }
            onClick={() => dispatch(toggleTheme())}
          /> */}
      </div>
          </Containers>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
